import { db } from "@/firebase";
import Store from "./../index";

const ClientStore = {
  state: {
    clients: null
  },

  mutations: {
    SET_CLIENTS(state, clients) {
      state.clients = clients;
    },
    ADD_CLIENT(state, params) {
      params.client.id = params.ref.id;
      state.clients.unshift(params.client);
    },
    UPDATE_CLIENT(state, params) {
      state.clients[params.client.index] = params.client;
    },
    DELETE_CLIENT(state, client) {
      state.clients.splice(state.clients.indexOf(client), 1);
    }
  },

  getters: {
    clients: state => state.clients,
    clientById: state => id => {
      if (state.clients) {
        return state.clients.filter(client => {
          return client.id === id;
        })[0];
      }
    }
  },

  actions: {
    getClients({ commit }, organisation) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(organisation)
          .collection("clients")
          .orderBy("company", "asc")
          .get()
          .then(
            querySnapshot => {
              let data = [];
              let index = 0
              querySnapshot.forEach(function(doc) {
                let obj = doc.data();
                obj.id = doc.id;
                obj.index = index;
                data.push(obj);
                index++;
              });
              commit("SET_CLIENTS", data);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    addClient({ commit }, client) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("clients")
          .add(client)
          .then(function(ref) {
            commit("ADD_CLIENT", { ref: ref, client: client });
            resolve(client);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    updateClient({ commit }, client) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("clients")
          .doc(client.id)
          .set(client)
          .then(function() {
            commit("UPDATE_CLIENT", { client: client });
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    deleteClient({ commit }, client) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("clients")
          .doc(client.id)
          .delete()
          .then(function() {
            commit("DELETE_CLIENT", client);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  }
};

export default ClientStore;
